import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putUser = (token, id, FirstName, LastName, Email, MobileNumber, SystemAdmin) => {
    const body = {}

    if(FirstName) {
        body.FirstName = FirstName
    }

    if(LastName) {
        body.LastName = LastName
    }

    if(Email) {
        body.Email = Email
    }

    if(MobileNumber) {
        body.MobileNumber = MobileNumber
    }
    
    if(typeof SystemAdmin === "boolean") {
        body.SystemAdmin = SystemAdmin ? "true" : "false"
    }

    return fetch(`${apiUrl}users/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
}

export default putUser